<template>
  <CCard>
    <CCardHeader>
      <strong>New Daily Task</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
          <CCol sm="12">
            <CSelect label="Category" :options="categories" :value.sync="category_id" @change="getTopics" />
          </CCol>
        <CCol sm="12">
          <CSelect label="Category" :options="topics" :value.sync="topic_id"/>
        </CCol>
        <CCol sm="12">
          <CInput label="No. of Games" type="number" placeholder="No. of Games" v-model="game_count" />
        </CCol>
        <CCol sm="12">
          <CInput label="Coins Reward" type="number" placeholder="Coins Reward" v-model="coins" />
        </CCol>
        <CCol sm="12">
          <CInput label="Gems Reward" type="number" placeholder="Gems Reward" v-model="gems" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <label>Task Duration</label>
          <VueCtkDateTimePicker label="Start Time" color="#0097FE" v-model="start_time" />
        </CCol>
      <CCol sm="12">
        <VueCtkDateTimePicker label="End Time"  color="#0097FE" v-model="end_time" />
      </CCol>
    </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary"><CIcon name="cil-check-circle"/> Add Daily Task</CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL
export default {
  name: "DailyTaskCreate",
  data() {
    return {
      categories : [{ value: null, label: 'Any Category'}],
      topics: [{ value: null, label: 'Any Topic'}],
      category_id: '',
      topic_id: '',
      coins: '',
      gems: '',
      start_time: '',
      end_time: '',
      game_count: 10,
    }
  },
  created() {
    this.getCategories()
  },
  methods : {
    getCategories() {
      this.categories = [{ value: null, label: 'Any Category'}]
      this.$axios
          .get(`${ADMIN_URL}/categories`)
          .then((response) => {
            response.data.category_list.forEach((e) => {
              this.categories.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    getTopics() {
      this.topics = [{ value: null, label: 'Any Topic'}]
      this.$axios
          .get(`${ADMIN_URL}/topics`,{
            params: {
              category_id : this.category_id
            }
          })
          .then((response) => {
            response.data.topic_list.forEach((e) => {
              this.topics.push({
                value: e.id,
                label: e.name,
              });
            });
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          'Accept' : 'application/json',
        }
      };

      let data = {}
      data.category_id = this.category_id
      data.topic_id = this.topic_id
      data.game_count = this.game_count
      data.gems = this.gems
      data.coins = this.coins
      data.start_time = this.start_time
      data.end_time = this.end_time


      this.$axios.post(`${ADMIN_URL}/daily-tasks`,data)
          .then(response => {
            console.log('Success', response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal('Success',response.data.message,'success');
            window.location.href='/daily-tasks'
          })
          .catch(error => {
            console.log('Error  ... ', error.response);
            currentObj.output = error;
            this.$swal('Error',error.response.message,'error');
          });
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
